module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('Badge', {
    attrs: {
      "count": _vm.count
    }
  }, [_c('a', {
    on: {
      "click": _vm.showEmailNews
    }
  }, [_c('Icon', {
    attrs: {
      "type": "email",
      "size": "50",
      "color": "#e3e8ee"
    }
  })], 1)]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateUserAllMessageNeedAlertStatus()
      }
    }
  }, [_vm._v("一键关闭弹窗提醒")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4fc7528","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message.vue
// module id = 1940
// module chunks = 8